module.exports = __webpack_public_path__ + "static/media/amz_REAR_VIEW_08.73ae957b.svg";